export const brandingDefinitions = {
  data() {
    return {
      brandingDefinitions: {
        // New attributes for dynamic property generation
        aboutAndCertifications: [
          {
            prefix: 'aboutCompany',
            visibility: false, // aboutCompany was NOT in original textsVisibility
            defaultText: {
              header: "It's all about trust",
              subheader: 'Discover how we protect your data.',
            },
          },
          {
            prefix: 'certifications',
            visibility: false, // certifications was NOT in original textsVisibility
            page: {
              alias: 'compliancePage', // Exception: compliancePage instead of certificationsPage
            },
            legacyNames: {
              pageHeaderPrefix: 'compliance', // compliance is conceptually same as certifications
            },
            defaultText: {
              header: 'Compliance',
              subheader: 'See below our compliance with industry standards.',
            },
          },
        ],

        pages: [
          {
            prefix: 'dataTypes',
            // dataTypesPage follows standard pattern, no page object needed
            legacyNames: {
              visibilityHeader: 'dataTypeHeader', // legacy: dataTypeHeader not dataTypesHeader
              textContentHeader: 'dataTypeHeader', // legacy: same as visibility
              textContentSubheader: 'dataTypesSubheader', // legacy: dataTypesSubheader not dataTypeSubheader
            },
            defaultText: {
              header: 'Quick Summary',
              subheader: 'Discover core facts about how we protect your data.',
            },
          },
          {
            prefix: 'customers',
            // customersPage and customersSection follow standard pattern, no objects needed
            legacyNames: {
              borderColor: 'customersCard', // legacy: customersCard not customers
            },
            defaultText: {
              header: 'Customers',
              subheader: 'We are proud to have such customers trusting us.',
            },
          },
          {
            prefix: 'subprocessors',
            // subprocessorsPage and subprocessorsSection follow standard pattern, no objects needed
            legacyNames: {
              borderColor: 'subprocessorsCard', // legacy: subprocessorsCard not subprocessors
            },
            defaultText: {
              header: 'Subprocessors',
              subheader: 'Here is the list of our subprocessors.',
            },
          },
          {
            prefix: 'securityLibrary',
            page: {
              aliases: ['securityLibraryPage', 'docsPage'], // Exception: includes docsPage alias
            },
            borderColor: false, // missing border color
            legacyNames: {
              docsBorderColor: 'docCardNew', // docs is associated with securityLibrary
              docsPageSubheader: 'docsPageSubheader', // docs page subheader was in original
              // color properties ARE present in original (not disabled)
            },
            defaultText: {
              header: 'Documents',
              subheader:
                'Navigate between all our published documents. Request access to locked documents.',
            },
          },
          {
            prefix: 'controls',
            // securityConfigPage and securityConfigSection follow standard pattern, no objects needed
            defaultText: {
              header: 'Controls',
              subheader: 'Find below our list of controls.',
            },
          },
          {
            prefix: 'securityConfig',
            // securityConfigPage and securityConfigSection follow standard pattern, no objects needed
            defaultText: {
              header: 'Security Setup',
              subheader: 'Find below our recommended security setup.',
            },
          },
          {
            prefix: 'team',
            // teamPage follows standard pattern, no page object needed
            borderColor: false, // missing border color
            defaultText: {
              header: 'Team',
              subheader: 'Meet our team members below.',
            },
          },
          {
            prefix: 'updates',
            // updatesPage and updatesSection follow standard pattern, no objects needed
            defaultText: {
              header: 'Updates',
              subheader: 'See below our list of updates.',
            },
          },
        ],

        gradients: [
          {
            prefix: 'footer',
            cssAttribute: '--footer-logo-bg-color',
          },
          {
            prefix: 'docCardNew',
            cssAttribute: '--doc-card-new-bg-color',
          },
          {
            prefix: 'docCardNewOverview',
            cssAttribute: '--doc-card-new-bg-color-overview',
          },
          {
            prefix: 'complianceCardNew',
            cssAttribute: '--compliance-card-new-bg-color',
          },
          {
            prefix: 'customersCardNew',
            cssAttribute: '--customers-card-new-bg-color',
          },
          {
            prefix: 'subprocessorsCardNew',
            cssAttribute: '--subprocessors-card-new-bg-color',
          },
          {
            prefix: 'teamCardNew',
            cssAttribute: '--team-card-new-bg-color',
          },
          {
            prefix: 'controlCardNew',
            cssAttribute: '--control-card-new-bg-color',
          },
          {
            prefix: 'updatesCard',
            cssAttribute: '--updates-card-new-bg-color',
          },
          {
            prefix: 'updatesCardNew',
            cssAttribute: '--updates-card-new-bg-color-page',
          },
          {
            prefix: 'securityConfig',
            cssAttribute: '--security-config-bg-color',
          },
          {
            prefix: 'securityConfigNew',
            cssAttribute: '--security-config-bg-color-new',
          },
          {
            prefix: 'customersCard',
            cssAttribute: '--customers-bg-color',
          },
          {
            prefix: 'subprocessorsCard',
            cssAttribute: '--subprocessors-bg-color',
          },
          {
            prefix: 'mainNavbarBg',
            cssAttribute: '--secondary-navbar-bg-color',
          },
          {
            prefix: 'aboutCompany',
            cssAttribute: '--about-company-bg-color',
          },
          {
            prefix: 'certifications',
            cssAttribute: '--certifications-bg-color',
          },
          {
            prefix: 'dataTypeRight',
            cssAttribute: '--data-types-bg-color',
            defaultColor: '#edeff2',
          },
          {
            prefix: 'overviewContainerFirstSection',
            cssAttribute: '--overview-container-first-section-bg-color',
          },
          {
            prefix: 'overviewContainerSecondSection',
            cssAttribute: '--overview-container-second-section-bg-color',
            defaultColor: '#E8F1FA',
          },
          {
            prefix: 'overviewContainerThirdSection',
            cssAttribute: '--overview-container-third-section-bg-color',
          },
          {
            prefix: 'overviewContainerControlsSection',
            cssAttribute: '--overview-container-controls-section-bg-color',
          },
          {
            prefix: 'customersSection',
            cssAttribute: '--customers-section-bg-color',
            defaultColor: '#E8F1FA',
          },
          {
            prefix: 'subprocessorsSection',
            cssAttribute: '--subprocessors-section-bg-color',
          },
          {
            prefix: 'securitySettingsSection',
            cssAttribute: '--security-settings-section-bg-color',
            defaultColor: '#E8F1FA',
          },
          {
            prefix: 'updatesSection',
            cssAttribute: '--updates-section-bg-color',
          },
          {
            prefix: 'compliancePageBgColor',
            cssAttribute: '--compliance-page-bg-color',
          },
          {
            prefix: 'documentsPageBgColor',
            cssAttribute: '--documents-page-bg-color',
          },
          {
            prefix: 'controlsPageBgColor',
            cssAttribute: '--controls-page-bg-color',
          },
          {
            prefix: 'customersPageBgColor',
            cssAttribute: '--customers-page-bg-color',
          },
          {
            prefix: 'subprocessorsPageBgColor',
            cssAttribute: '--subprocessors-page-bg-color',
          },
          {
            prefix: 'securityConfigPageBgColor',
            cssAttribute: '--security-config-page-bg-color',
          },
          {
            prefix: 'teamPageBgColor',
            cssAttribute: '--team-page-bg-color',
          },
          {
            prefix: 'updatesPageBgColor',
            cssAttribute: '--updates-page-bg-color',
          },
          {
            prefix: 'updatesCardBgColor',
            cssAttribute: '--updates-card-bg-color',
          },
          {
            prefix: 'searchResultsPageBgColor',
            cssAttribute: '--search-results-page-bg-color',
            defaultColor: null,
          },
        ],
      },
    }
  },
}
